import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "@/App";
import { AuthProvider } from "@/auth/AuthProvider";
import { configureAmplify } from "@/auth/amplify";
import { initAnalytics } from "@/analytics";
import { startThemeSchedule } from "@/lib/theme";
import { loadRuntimeConfig } from "@/lib/runtime-config";
import "@/styles/globals.css";

// Applied before first paint so the app never flashes light then swaps to dark.
// Independent of runtime config, so it runs before the fetch below.
startThemeSchedule();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

// The bundle is built once and promoted across environments, so per-env
// values (API origin, Cognito pool, Mixpanel token) arrive via /config.json
// at boot rather than import.meta.env. Nothing that reads them may run until
// the loader settles — it never rejects, falling back to build-time env when
// the file is absent (local dev, e2e).
loadRuntimeConfig().then(() => {
  configureAmplify();
  initAnalytics();

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
  );
});
